module.exports = __webpack_public_path__ + "static/media/man-in-canoe.804210d7.png";